import { SVGProps } from 'react';
const SvgArrowDownRightLg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m5 5 14 14M19 11v8h-8"
    />
  </svg>
);
export default SvgArrowDownRightLg;
